import { formatDate, formatNumber, getTradeUnit, RFQBuyerModel, TranslateFunc } from '@steelbuy/ts-shared';
import { buildRangeProductName, getQualityDisplayValue } from '@steelbuy/util';

const TO_SHOW_LISTINGS_NUMBER = 2;

export const myRfqsTableHeading = [
    'rfqReferenceNo',
    'createdAt',
    'materialSpecs',
    'quality',
    'totalWeight',
    'rfqStatus',
];

type QuoteTableConfig = Record<
    string,
    {
        getHeading: (t: TranslateFunc) => string;
        mapValue?: (quote: RFQBuyerModel, t: TranslateFunc) => string | string[] | number | undefined;
    }
>;

const getMaterialSpecifications = (quote: RFQBuyerModel, t: TranslateFunc): string[] => {
    const entries = quote.quoteEntry;

    const visibleEntries = entries.slice(0, TO_SHOW_LISTINGS_NUMBER).map((entry) => buildRangeProductName(entry, t));

    if (entries.length > TO_SHOW_LISTINGS_NUMBER) {
        visibleEntries.push(
            t('application.myQuotes.extraListingsCount', {
                count: entries.length - TO_SHOW_LISTINGS_NUMBER,
            })
        );
    }

    return visibleEntries;
};

export const quoteTableConfig: QuoteTableConfig = {
    rfqReferenceNo: {
        getHeading: (t) => t('application.myQuotes.tableHeadings.rfqReferenceNo'),
        mapValue: (quote) => quote.quoteReferenceNumber,
    },
    createdAt: {
        getHeading: (t) => t('application.myQuotes.tableHeadings.createdAt'),
        mapValue: (quote) => formatDate(new Date(quote?.createdAt.value)),
    },
    materialSpecs: {
        getHeading: (t) => t('application.myQuotes.tableHeadings.materialSpecs'),
        mapValue: getMaterialSpecifications,
    },
    quality: {
        getHeading: (t) => t('application.rfqHeadingLabels.quality'),
        mapValue: (quote, t) => {
            const qualities = [...new Set(quote.quoteEntry.map((entry) => entry?.quality))];
            return qualities.map((q) => getQualityDisplayValue(q, null, t)).join(', ');
        },
    },
    totalWeight: {
        getHeading: (t) => t('application.myQuotes.tableHeadings.totalWeight'),
        mapValue: (quote, t) =>
            t(
                `domainModel:material.tradeUnit.value.${getTradeUnit({
                    materialType: quote.quoteEntry[0].material.materialType,
                })}.quantity`,
                {
                    count: quote.totalWeight,
                    formatted: formatNumber(quote.totalWeight),
                }
            ),
    },
    rfqStatus: {
        getHeading: (t) => t('application.myQuotes.tableHeadings.rfqStatus'),
        mapValue: (quote, t) => t(`application.myQuotes.rfqStatus.${quote.status.value}`),
    },
};
